/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.AIReceptionist {
    /**
     * Registers the meevo-ai-receptionist custom element. No feature gate here — the
     * Management-menu tile's securityKey and the backend's [CheckAccess] do the gating.
     */
    angular.module("meevo.plugins.aiReceptionist", [])
        .run(['webComponentSetup', function (webComponentSetup: any) {
            webComponentSetup.register({
                id: 'ai-receptionist',
            });
        }]);
}
